module.exports = __webpack_public_path__ + "img/valance-trojan.5e04953e.svg";